import {IMGPIXID} from 'src/consts'

export function getCurrentURL() {
  const imgpixEl = document.getElementById(IMGPIXID) as HTMLImageElement
  if (imgpixEl) {
    const path = imgpixEl.src
    console.log('pixel: ', path)
    const indexOfSlash = path.lastIndexOf('/')
    return path.slice(0, indexOfSlash + 1)
  }
  return ''
}
